module.exports = __webpack_public_path__ + "img/E2E2E7_AEAEB5_C4C4CC_C4C4C4-256px.efba435d.png";